<template>
  <div class="item" :class="{flex: h5Options.row === 1}">
    <div class="img">
      <img v-lazy="item.imgUrl" />
    </div>
    <div class="info">
      <p class="title">{{item.title}}</p>
      <input class="pwd" :value="pwd" v-if="pwd">
      <div class="btns" :class="{'flex justify-between': h5Options.row !== 3}">
        <button class="flex-1 entry-btn" v-if="!isWeixin" @click="handleJump" :style="{backgroundColor: h5Options.btnBgColor, color: h5Options.color}">进入会场</button>
        <button class="flex-1 copy-btn" @click="handleCopy" :style="{backgroundColor: h5Options.btnBgColor, color: h5Options.color}">一键复制</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import * as services from '@/services/activity'


  export default {
    name: 'SubListItem',
    data() {
      return {
        pwd: '',
        url: ''
      }
    },
    props: {
      item: {
        type: Object,
      },
      h5Options: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      ...mapState([
        'userInfo',
      ]),
      ...mapGetters([
        'isWeixin'
      ]),
    },
    methods: {
      ...mapActions(['handleJumpAction', 'handleCopyAction']),
      async handleJump () {
        await this.transform()
        this.handleJumpAction({
          url: this.url
        })
      },
      async handleCopy () {
        await this.transform()
        this.handleCopyAction({
          copyText: this.pwd,
        })
      },
      async transform () {
        if (this.pwd) {
          return 1
        }
        const params = {
          pid: this.userInfo.pid,
          relationId: this.userInfo.relationId,
          activityId: this.item.activityId,
          title: this.item.title,
          imageUrl: this.item.imgUrl
        }
        const res = await services.getActivityRes(params);
        if (res.status === 1) {
          this.pwd = res.data.pwd;
          this.url = res.data.url;
        }
      }
    },
    created () {
    },
  }
</script>

<style scoped>

</style>
